import { PageShell } from "~/components/layout/page-shell";
import { ProfileIdentityHeader } from "~/components/profile-identity-header";
import { m } from "~/lib/i18n";
import { Skeleton } from "~/components/ui/skeleton";

/** Keep profile geometry visible while its lazy code loads; no data imports. */
export function UserProfilePagePending() {
  return (
    <PageShell className="bg-background" contentClassName="gap-5" size="wide">
      <PageShell.Header>
        <div className="flex flex-col gap-5 sm:flex-row sm:items-end sm:justify-between">
          <div className="min-w-0">
            <div className="flex flex-wrap items-center gap-2 text-meta text-muted-foreground">
              <span>{m.user_profile_page_user_label()}</span>
              <span className="text-border">/</span>
              <Skeleton className="h-4 w-20" />
            </div>
            <ProfileIdentityHeader
              className="mt-4"
              name=""
              imageUrl={null}
              avatarLoading
              nameLoading
            />
          </div>
          <Skeleton className="h-8 w-24 rounded-full" />
        </div>
      </PageShell.Header>
      <PageShell.Main>
        <Skeleton className="h-80 w-full rounded-lg" />
        <Skeleton className="h-48 w-full rounded-lg" />
      </PageShell.Main>
      <PageShell.Rail className="hidden lg:block" width="lg">
        <Skeleton className="h-20 w-full rounded-lg" />
      </PageShell.Rail>
    </PageShell>
  );
}
